import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_110: FaireProductEntity = {
  token: "legacy_prod_abbott-110",
  type: "product",
  name: "Olive Branch Planter",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c6ddcb96d9f18a66df744b0a37f9c1f323e3b3d798d2fa59768566140e8fbe2f.jpeg",
  priceDollars: 24,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
